/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
} from './SourceContact';

/**
 * 
 * @export
 * @interface CreateSourceContact201Response
 */
export interface CreateSourceContact201Response {
    /**
     * 
     * @type {SourceContact}
     * @memberof CreateSourceContact201Response
     */
    data?: SourceContact;
}

/**
 * Check if a given object implements the CreateSourceContact201Response interface.
 */
export function instanceOfCreateSourceContact201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateSourceContact201ResponseFromJSON(json: any): CreateSourceContact201Response {
    return CreateSourceContact201ResponseFromJSONTyped(json, false);
}

export function CreateSourceContact201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSourceContact201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SourceContactFromJSON(json['data']),
    };
}

export function CreateSourceContact201ResponseToJSON(value?: CreateSourceContact201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SourceContactToJSON(value.data),
    };
}

